import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import { IStatus } from './status.model';
import { IUserInfo, AuthService } from '../shared/core/index';
import { HttpService } from '../shared/core/http.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class StatusService {
    private _userInfo: IUserInfo;
    private _statusAPIUrl = new URL('status', environment.apiUrl).toString();

    constructor(private _httpService: HttpService, private authService: AuthService) {
        this.authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }

    getDepartmentStatuses(department: string): Observable<IStatus[]> {
        const url = new URL(this._statusAPIUrl).toString();

        return this._httpService.httpGet(url + "/getdepartmentstatuses?department=" + department).pipe(
            map((response) => {
                return this.mapStatuses(response);
            }),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    mapStatuses(response): IStatus[] {
        return response.map(r => this.toStatus(r));
    }

    toStatus(r: any): IStatus {

        let statuses = <IStatus>
            ({
                statusId: r.statusId,
                statusName: r.StatusName
            });

        return statuses;
    }

    private handleError(error: Response) {
        return throwError(() => error || 'Server error');
    }
}